import { typedAction } from "../actionTypes";
import { LocationInfo, LocationState } from "../location/locationModels";
import {
  RESTAURANT_DETAIL_REQUEST,
  RESTAURANT_DETAIL_FAILURE,
  RESTAURANT_DETAIL_SUCCESS,
  RESTAURANT_MENU_DETAIL_REQUEST,
  RESTAURANT_MENU_DETAIL_FAILURE,
  RESTAURANT_MENU_DETAIL_SUCCESS,
  FEEDBACK_DETAIL_REQUEST,
  FEEDBACK_DETAIL_FAILURE,
  FEEDBACK_DETAIL_SUCCESS,
  SUBMIT_FEEDBACK_DETAIL_REQUEST,
  SUBMIT_FEEDBACK_DETAIL_FAILURE,
  SUBMIT_FEEDBACK_DETAIL_SUCCESS,
  STORE_MENU_ITEM,
  RESTAURANTS_REQUEST,
  RESTAURANTS_FAILURE,
  RESTAURANTS_SUCCESS,
  STORE_SELECTED_LOCATION,
  CLEAR_SELECTED_LOCATION,
  REFRESH_MENU_DETAIL,
  STORE_RESTAURANT_SERVING_LOCATIONS,
  SERVING_RESTAURANTS_REQUEST,
  SERVING_RESTAURANTS_FAILURE,
  SERVING_RESTAURANTS_SUCCESS,
  RESTAURANT_DETAIL_LOCATION_ID_REQUEST,
  RESTAURANT_DETAIL_LOCATION_ID_SUCCESS,
  RESTAURANT_DETAIL_LOCATION_ID_CLEAR,
  ACTIVE_ORDER_RESTAURANT_REQUEST,
  ACTIVE_ORDER_RESTAURANT_CLEAR,
  ACTIVE_ORDER_RESTAURANT_SUCCESS,
  GET_MASTER_HOME_PAGE_DETAILS,
  GET_MASTER_HOME_PAGE_DETAILS_SUCCESS,
  GET_MASTER_HOME_PAGE_DETAILS_ERROR,
  CLEAR_RESTAURANT_DETAIL,
  CLEAR_FEEDBACK_DATA,
  GET_RESTAURANT_TABLE_DETAILS,
  GET_RESTAURANT_TABLE_DETAILS_SUCCESS,
  GET_RESTAURANT_TABLE_DETAILS_FAILED,
  RESTAURANT_ORDER_TYPE_SWITCH_SUCCESS,
  UPDATE_CD_GUEST_COUNT,
  RESTAURANT_MENU_DETAIL_REQUEST_BY_DATE,
  UPDATE_RESTAURANT_STATUS,
  CURRENT_ORDERTYPE_ID,
  CURRENT_CUSTOMIZATION_ID,
  DELIVERY_ADDRESSES,
  SELECTED_DELIVERY_ADDRESS,
  CURRENT_ORDER_TYPE,
  ADD_ADDRESS_TAGS,
  ADD_DELIVERY_ADDRESS_REQUEST,
  ADD_DELIVERY_ADDRESS_SUCCESS,
  ADD_DELIVERY_ADDRESS_FAILURE,
  VIEW_DELIVERY_ADDRESS_REQUEST,
  VIEW_DELIVERY_ADDRESS_SUCCESS,
  VIEW_DELIVERY_ADDRESS_FAILURE,
  EDIT_DELIVERY_ADDRESS_REQUEST,
  EDIT_DELIVERY_ADDRESS_SUCCESS,
  EDIT_DELIVERY_ADDRESS_FAILURE,
  DELETE_DELIVERY_ADDRESS_REQUEST,
  DELETE_DELIVERY_ADDRESS_SUCCESS,
  DELETE_DELIVERY_ADDRESS_FAILURE,
  ADD_FAV_REQUEST,
  ADD_FAV_SUCCESS,
  ADD_FAV_FAILURE,
  REMOVE_FAV_SUCCESS,
  REMOVE_FAV_FAILURE,
  REMOVE_FAV_REQUEST,
  GET_FAV_REQUEST,
  GET_FAV_SUCCESS,
  GET_FAV_FAILURE,
  SET_SELECTED_RESTAURANT_TAB,
  SET_SELECTED_DELIVERY_TYPE,
  GET_EXPLORE_MENU_REQUEST,
  GET_EXPLORE_MENU_SUCCESS,
  GET_EXPLORE_MENU_FAILURE,
  REMOVE_DELIVERY_ADDRESS,
  IS_ANNOUNCEMENT_OPEN,
  TOGGLE_CLICK,
  // Add and Remove Fav Icons the i cons blink every icon  Resolve Start 

  SET_FAV_MAP,
  UPDATE_FAV_MAP,
  RESET_RESTAURANT,
  IS_EXPLORE_TAB_ACTIVE,
  TOGGLE_STATUS,
  SELECTED_INGREDIENT_CHECKLIST,
  GET_COUPONS_REQUEST,
  GET_COUPONS_SUCCESS,
  GET_COUPONS_FALIURE,
  VALIDATE_COUPONS_REQUEST,
  VALIDATE_COUPONS_SUCCESS,
  VALIDATE_COUPONS_FALIURE,
  REDEEM_COUPONS_REQUEST,
  REDEEM_COUPONS_SUCCESS,
  REDEEM_COUPONS_FALIURE,
  APPLIED_COUPON,
  CLEAR_APPLIED_COUPON,
  VALIDATE_COUPONS_MSG_CLEAR,
  VALIDATE_COUPONS_FALIURE_MESSAGE

  // End
} from "./restaurantContants";
import {
  RestaurantDetail,
  RestaurantDetailFailResult,
  RestaurantMenuItem,
  RestaurantMenuDetailFailResult,
  SubmitFeedbackDetail,
  FeedbackQuestion,
  RestaurantMenuRequest,
  RestaurantMenuResponse,
  RestaurantItemDetail,
  RestaurantsRequestParams,
  RestaurantDetailRequest,
  RestaurantDetailByLocationIdRequest,
  RestaurantTableDetails,
  restarauntPayload,
  TogglesStructure,
} from "./restaurantModels";

// Store selected location
export function storeSelectedLocation(details: LocationInfo) {
  return typedAction(STORE_SELECTED_LOCATION, details);
}

export function clearSelectedLocation() {
  return typedAction(CLEAR_SELECTED_LOCATION, "");
}

// Get Restaurants
export function getRestaurantsRequest(
  locationParams: RestaurantsRequestParams
) {
  return typedAction(RESTAURANTS_REQUEST, locationParams);
}

export function failedRestaurants(detail: RestaurantDetailFailResult) {
  // Replace any with Network Data Fail Data format
  return typedAction(RESTAURANTS_FAILURE, detail);
}

export function successRestaurants(details: RestaurantItemDetail[]) {
  return typedAction(RESTAURANTS_SUCCESS, details);
}

// Get Serving Locations
export function getServingLocations(locationParams: RestaurantsRequestParams) {
  return typedAction(SERVING_RESTAURANTS_REQUEST, locationParams);
}

export function failedGetServingLocations(detail: RestaurantDetailFailResult) {
  // Replace any with Network Data Fail Data format
  return typedAction(SERVING_RESTAURANTS_FAILURE, detail);
}

export function successGetServingLocations(details: RestaurantItemDetail[]) {
  return typedAction(SERVING_RESTAURANTS_SUCCESS, details);
}

export function storeServingLocations(details: RestaurantItemDetail[]) {
  return typedAction(STORE_RESTAURANT_SERVING_LOCATIONS, details);
}

// Restaurant Details
export function getRestaurantDetails(slug: string, merchantType?: string) {
  // Store Merchant Type
  // merchantType && storeMerchantType(merchantType);

  return typedAction(RESTAURANT_DETAIL_REQUEST, {
    slug: slug,
    merchantType: merchantType,
  } as RestaurantDetailRequest);
}

// Restaurant Details
export function getRestaurantDetailsWithCallback(details: restarauntPayload) {
  // Store Merchant Type
  // merchantType && storeMerchantType(merchantType);

  return typedAction(RESTAURANT_DETAIL_REQUEST, {
    slug: details?.slug,
    merchantType: details?.merchantType,
    sagaCallBack: details?.sagaCallBack,
    render:details?.render,
  } as RestaurantDetailRequest);
}

// Active order Restaurant

export function getActiveOrderRestaurant(
  details: RestaurantDetailByLocationIdRequest
) {
  return typedAction(ACTIVE_ORDER_RESTAURANT_REQUEST, details);
}

export function getActiveOrderRestaurantSuccess(details: RestaurantDetail) {
  return typedAction(ACTIVE_ORDER_RESTAURANT_SUCCESS, details);
}

export function clearActiveOrderRestaurant() {
  return typedAction(ACTIVE_ORDER_RESTAURANT_CLEAR, "");
}

export function getRestaurantDetailsByLocationId(
  details: RestaurantDetailByLocationIdRequest
) {
  return typedAction(RESTAURANT_DETAIL_LOCATION_ID_REQUEST, details);
}

export function getRestaurantDetailsByLocationIdSuccess({
  details,
  isEventOrder,
}: any) {
  return typedAction(RESTAURANT_DETAIL_LOCATION_ID_SUCCESS, {
    details,
    isEventOrder,
  });
}

export function clearRestaurantDetailsByLocationId() {
  return typedAction(RESTAURANT_DETAIL_LOCATION_ID_CLEAR, "");
}

export function failedRestaurantDetails(detail: RestaurantDetailFailResult) {
  // Replace any with Network Data Fail Data format
  return typedAction(RESTAURANT_DETAIL_FAILURE, detail);
}

export function successRestaurantDetails({ detail, isEventOrder }: any) {
  return typedAction(RESTAURANT_DETAIL_SUCCESS, { detail, isEventOrder });
}

// Restaurant Menu Details
export function refreshRestaurantMenuDetails() {
  return typedAction(REFRESH_MENU_DETAIL, "");
}

export function clearMenuDetails() {
  return typedAction(CLEAR_RESTAURANT_DETAIL, "");
}

export function getRestaurantMenuDetails(details: RestaurantMenuRequest) {
  return typedAction(RESTAURANT_MENU_DETAIL_REQUEST, details);
}

export function getRestaurantMenuDetailsbyDate(details: RestaurantMenuRequest) {
  return typedAction(RESTAURANT_MENU_DETAIL_REQUEST_BY_DATE, details);
}

export function updateCdGuestCount(guestCount: Number) {
  return typedAction(UPDATE_CD_GUEST_COUNT, guestCount);
}

export function failedRestaurantMenuDetails(
  detail: RestaurantMenuDetailFailResult
) {
  // Replace any with Network Data Fail Data format
  return typedAction(RESTAURANT_MENU_DETAIL_FAILURE, detail);
}

export function successRestaurantMenuDetails(detail: RestaurantMenuResponse) {
  return typedAction(RESTAURANT_MENU_DETAIL_SUCCESS, detail);
}

export function orderTypeSwitch(detail: any) {
  return typedAction(RESTAURANT_ORDER_TYPE_SWITCH_SUCCESS, detail);
}

// Survey/Feedback Details
export function getFeedbackDetails() {
  return typedAction(FEEDBACK_DETAIL_REQUEST, "");
}
export function failedFeedbackDetails() {
  // Replace any with Network Data Fail Data format
  return typedAction(FEEDBACK_DETAIL_FAILURE, "");
}
export function successFeedbackDetails(details: FeedbackQuestion[]) {
  return typedAction(FEEDBACK_DETAIL_SUCCESS, details);
}

export function clearFeedbackData() {
  return typedAction(CLEAR_FEEDBACK_DATA, "");
}

// Survey / Feedback submit
export function submitFeedbackDetails(details: SubmitFeedbackDetail) {
  return typedAction(SUBMIT_FEEDBACK_DETAIL_REQUEST, details);
}
export function failedSubmitFeedbackDetails() {
  // Replace any with Network Data Fail Data format
  return typedAction(SUBMIT_FEEDBACK_DETAIL_FAILURE, "Failed submit");
}
export function successSubmitFeedbackDetails() {
  return typedAction(
    SUBMIT_FEEDBACK_DETAIL_SUCCESS,
    "Feedback Submitted Successfully"
  );
}

// Master Restaurant Home Page
export function getMasterHomePageDetails(slug: string) {
  return typedAction(GET_MASTER_HOME_PAGE_DETAILS, slug);
}

export function getMasterHomePageDetailsSuccess(detail: RestaurantDetail) {
  return typedAction(GET_MASTER_HOME_PAGE_DETAILS_SUCCESS, detail);
}

export function getMasterHomePageDetailsFailed() {
  return typedAction(GET_MASTER_HOME_PAGE_DETAILS_ERROR, "");
}

// Get Restaurant Table Details
export function getRestaurantTableDetailsRequest(resId: string) {
  return typedAction(GET_RESTAURANT_TABLE_DETAILS, resId);
}

export function getRestaurantTableDetailsSuccess(
  tableDetails: RestaurantTableDetails[]
) {
  return typedAction(GET_RESTAURANT_TABLE_DETAILS_SUCCESS, tableDetails);
}

export function getRestaurantTableDetailsFailed() {
  return typedAction(GET_RESTAURANT_TABLE_DETAILS_FAILED, "");
}

export function updateRestaurantDetailsLoaderStatus(status: boolean) {
  return typedAction(UPDATE_RESTAURANT_STATUS, status);
}
export function currentOrderType(id: string) {
  return typedAction(CURRENT_ORDERTYPE_ID, id);
}

export function setCurrentOrderType(type: string) {
  return typedAction(CURRENT_ORDER_TYPE, type);
}

export function customizationId(id: string) {
  return typedAction(CURRENT_CUSTOMIZATION_ID, id);
}

export function deliveryAddresses(data: any) {
  return typedAction(DELIVERY_ADDRESSES, data);
}

export function setSelectedDeliveryAddress(data: any) {
  return typedAction(SELECTED_DELIVERY_ADDRESS, data);
}

export function addAddressTags(data: any) {
  return typedAction(ADD_ADDRESS_TAGS, data);
}

//view address
export function viewDeliveryAddressRequest(){
  return typedAction(VIEW_DELIVERY_ADDRESS_REQUEST)
}

export function viewDeliveryAddressSuccess(data: any){
  return typedAction(VIEW_DELIVERY_ADDRESS_SUCCESS, data)
}

export function viewDeliveryAddressFailure(data: any){
  return typedAction(VIEW_DELIVERY_ADDRESS_FAILURE, data)
}

//add address
export function addDeliveryAddressRequest(data: any){
  return typedAction(ADD_DELIVERY_ADDRESS_REQUEST, data)
}

export function addDeliveryAddressSuccess(data: any){
  return typedAction(ADD_DELIVERY_ADDRESS_SUCCESS, data)
}

export function addDeliveryAddressFailure(data: any){
  return typedAction(ADD_DELIVERY_ADDRESS_FAILURE, data)
}

//edit address
export function editDeliveryAddressRequest(data: any){
  return typedAction(EDIT_DELIVERY_ADDRESS_REQUEST, data)
}

export function editDeliveryAddressSuccess(data: any){
  return typedAction(EDIT_DELIVERY_ADDRESS_SUCCESS, data)
}

export function editDeliveryAddressFailure(data: any){
  return typedAction(EDIT_DELIVERY_ADDRESS_FAILURE, data)
}

//delete address
export function deleteDeliveryAddressRequest(data: any){
  return typedAction(DELETE_DELIVERY_ADDRESS_REQUEST, data)
}

export function deleteDeliveryAddressSuccess(data: any){
  return typedAction(DELETE_DELIVERY_ADDRESS_SUCCESS, data)
}

export function deleteDeliveryAddressFailure(data: any){
  return typedAction(DELETE_DELIVERY_ADDRESS_FAILURE, data)
}
export function AddFavRequest(data: any) {
  
  return {
    type: ADD_FAV_REQUEST,
    payload: data,
    meta: { itemId: data.itemId[0] },
  };
}

export function AddFavSuccess(data: any) {
  return typedAction(ADD_FAV_SUCCESS, data);
}
export function AddFavFailure(data: any) {
  return typedAction(ADD_FAV_FAILURE, data);
}
export function RemoveFavRequest(data: any) {
  return {
    type: REMOVE_FAV_REQUEST,
    payload: data,
    meta: { itemId: data.itemId[0] },
  };
}

export function RemoveFavSuccess(data: any) {
  return typedAction(REMOVE_FAV_SUCCESS, data);
}
export function RemoveFavFailure(data: any) {
  return typedAction(REMOVE_FAV_FAILURE, data);
}
export function GetFavRequest(data: any) {
  return typedAction(GET_FAV_REQUEST, data);
}
export function GetFavSuccess(data: any) {
  return typedAction(GET_FAV_SUCCESS, data);
}
export function GetFavFailure(data: any) {
  return typedAction(GET_FAV_FAILURE, data);
}

//Explore Menu
export function exploreMenuRequest(data: any) {
  return typedAction(GET_EXPLORE_MENU_REQUEST, data)
}

export function exploreMenuSuccess(response: any) {
  return typedAction(GET_EXPLORE_MENU_SUCCESS, response)
}

export function exploreMenuFailure(data: any) {
  return typedAction(GET_EXPLORE_MENU_FAILURE, data)
}

// Selected Restaurant Tab
export const setSelectedRestaurantTab = (tab: string) =>
  typedAction(SET_SELECTED_RESTAURANT_TAB, tab);

// Selected Menu Type
export const setSelectedDeliveryType = (deliveryType: string) =>
  typedAction(SET_SELECTED_DELIVERY_TYPE, deliveryType);

export function removeDeliveryAddress(){
  return typedAction(REMOVE_DELIVERY_ADDRESS)
}

export function isAnnouncementOpen() {
  return typedAction(IS_ANNOUNCEMENT_OPEN)
}

export function toggleClick() {
  return typedAction(TOGGLE_CLICK)
}


// FavMap actions the issue Refresh Fav Icon handle Local state
export function setFavMap(favMap: Record<string, boolean>) {
  return typedAction(SET_FAV_MAP, favMap);
}

export function updateFavMap(payload: { itemId: string; isFav: boolean }) {
  return typedAction(UPDATE_FAV_MAP, payload);
}

export function resetRestaurant(data?:any) {
  return typedAction(RESET_RESTAURANT, data);
}

export function isExploretabActive(data?:boolean) {
  return typedAction(IS_EXPLORE_TAB_ACTIVE, data);
}

export function storeToggleStatus(data?:TogglesStructure)
{
  return typedAction(TOGGLE_STATUS,data)
}

export function storeSelectedIngredientChecklist(data: string[]) {
  return typedAction(SELECTED_INGREDIENT_CHECKLIST, data);
}

export function getCouponRequest(data: any) {
  return typedAction(GET_COUPONS_REQUEST, data)
}

export function getCouponSuccess(response: any) {
  return typedAction(GET_COUPONS_SUCCESS, response)
}

export function getCouponFailure(data: any) {
  return typedAction(GET_COUPONS_FALIURE, data)
}


export function validateCouponRequest(data: any) {
  return typedAction(VALIDATE_COUPONS_REQUEST, data)
}

export function validateCouponSuccess(response: any) {
  return typedAction(VALIDATE_COUPONS_SUCCESS, response)
}

export function validateCouponFailure(data: any) {
  return typedAction(VALIDATE_COUPONS_FALIURE, data)
}
export function validateCouponClearmsg() {
  return typedAction(VALIDATE_COUPONS_MSG_CLEAR, )
}

export function redeemCouponRequest(data: any) {
  return typedAction(REDEEM_COUPONS_REQUEST, data)
}

export function redeemCouponSuccess(response: any) {
  return typedAction(REDEEM_COUPONS_SUCCESS, response)
}

export function redeemCouponFailure(data: any) {
  return typedAction(REDEEM_COUPONS_FALIURE, data)
}
// Stacked-coupon model: dispatching `appliedCoupon(coupon)` adds it to
// the `appliedCoupons` array and replaces any existing coupon in the
// same category (ORDER / FREE_ITEM / FREE_DELIVERY).
export function appliedCoupon(data: any) {
  return typedAction(APPLIED_COUPON, data)
}

// Without a payload → clears every applied coupon (preserves the
// pre-stacking call sites). With { id } or { category } → removes only
// the matching entry.
export function clearAppliedCoupon(filter?: { id?: any; category?: 'ORDER' | 'FREE_ITEM' | 'FREE_DELIVERY' | 'BOGO' }) {
  return typedAction(CLEAR_APPLIED_COUPON, filter)
}

export function validateCouponFailureMessage(data: any){
  return typedAction(VALIDATE_COUPONS_FALIURE_MESSAGE, data)
}

export type restaurantActions = ReturnType<
  | typeof getRestaurantsRequest
  | typeof clearSelectedLocation
  | typeof failedRestaurants
  | typeof successRestaurants
  | typeof getRestaurantDetailsByLocationId
  | typeof getRestaurantDetailsByLocationIdSuccess
  | typeof clearRestaurantDetailsByLocationId
  | typeof getRestaurantDetails
  | typeof getRestaurantDetailsWithCallback
  | typeof failedRestaurantDetails
  | typeof successRestaurantDetails
  | typeof getRestaurantMenuDetails
  | typeof getRestaurantMenuDetailsbyDate
  | typeof failedRestaurantMenuDetails
  | typeof successRestaurantMenuDetails
  | typeof getFeedbackDetails
  | typeof failedFeedbackDetails
  | typeof successFeedbackDetails
  | typeof submitFeedbackDetails
  | typeof failedSubmitFeedbackDetails
  | typeof successSubmitFeedbackDetails
  | typeof storeSelectedLocation
  | typeof refreshRestaurantMenuDetails
  | typeof getServingLocations
  | typeof failedGetServingLocations
  | typeof successGetServingLocations
  | typeof storeServingLocations
  | typeof getActiveOrderRestaurant
  | typeof getActiveOrderRestaurantSuccess
  | typeof clearActiveOrderRestaurant
  | typeof getMasterHomePageDetails
  | typeof getMasterHomePageDetailsSuccess
  | typeof getMasterHomePageDetailsFailed
  | typeof clearMenuDetails
  | typeof clearFeedbackData
  | typeof getRestaurantTableDetailsRequest
  | typeof getRestaurantTableDetailsSuccess
  | typeof getRestaurantTableDetailsFailed
  | typeof orderTypeSwitch
  | typeof updateCdGuestCount
  | typeof updateRestaurantDetailsLoaderStatus
  | typeof currentOrderType
  | typeof customizationId
  | typeof deliveryAddresses
  | typeof setSelectedDeliveryAddress
  | typeof setCurrentOrderType
  | typeof addAddressTags
  | typeof addDeliveryAddressRequest
  | typeof addDeliveryAddressSuccess
  | typeof addDeliveryAddressFailure
  | typeof viewDeliveryAddressRequest
  | typeof viewDeliveryAddressSuccess
  | typeof viewDeliveryAddressFailure
  | typeof editDeliveryAddressRequest
  | typeof editDeliveryAddressSuccess
  | typeof editDeliveryAddressFailure
  | typeof deleteDeliveryAddressRequest
  | typeof deleteDeliveryAddressSuccess
  | typeof deleteDeliveryAddressFailure
  | typeof AddFavRequest
  | typeof AddFavSuccess
  | typeof AddFavFailure
  | typeof RemoveFavSuccess
  | typeof RemoveFavRequest
  | typeof RemoveFavFailure
  | typeof GetFavSuccess
  | typeof GetFavRequest
  | typeof GetFavFailure
  | typeof setSelectedRestaurantTab
  | typeof setSelectedDeliveryType
  | typeof exploreMenuRequest
  | typeof exploreMenuSuccess
  | typeof exploreMenuFailure
  | typeof removeDeliveryAddress
  | typeof isAnnouncementOpen
  | typeof toggleClick
  | typeof setFavMap
  | typeof updateFavMap
  | typeof resetRestaurant
  | typeof isExploretabActive
  | typeof storeToggleStatus
  | typeof storeSelectedIngredientChecklist
  | typeof getCouponRequest
  | typeof getCouponSuccess
  | typeof getCouponFailure
   | typeof validateCouponRequest
  | typeof validateCouponSuccess
  | typeof validateCouponFailure
   | typeof redeemCouponRequest
  | typeof redeemCouponSuccess
  | typeof redeemCouponFailure
  | typeof appliedCoupon
  | typeof clearAppliedCoupon
  | typeof validateCouponFailureMessage

>;
